<template>
  <div class="mb-header-pad">
    <div class="p-4">

      <div class="mb-4 d-flex algin-items-center">

        <FrameBtnUserLogin class="mr-3"/>
        <frameBtnAccount/>

        <!-- lang -->
        <FrameHeaderLangSelect class="ml-4 mb-ml-auto"/>
      </div>


      <!-- nav -->
      <FrameHeaderNav 
        class="sp-nav"
      />

      <FrameHeaderLink style="position: absolute; bottom: 20px;"/>
    </div>
  </div>
</template>

<script>

export default {
  name: 'mobileHeaderPad',
  components: {},
  props: [],
  data() {
    return {
      
    }
  },
  computed: {},
  watch: {},
  methods: {
    
  },
  created() {
    
  },
  //mounted() {},
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>
  @import '~@/assets/css/vars.scss';
  .mb-header-pad{
    width: 100vw;
    max-width: 100vw;
    position: fixed;
    left: 0;
    top: $h_header;
    bottom: 0;
    background-color: var(--bg-color);
    margin-left: -101vw;

    z-index: 10;

    &.on{
      transition: all .3s;
      margin-left: 0px;
    }

  }

  /deep/ .sp-nav{
    a{
      margin: 10px 0;
      padding: 5px 0;
    }
  }
</style>